<ng-container *ngIf="shouldShow">
  <div class="mat-subtitle-2 version">
    <span i18n>Version: </span> {{ version }}
  </div>
</ng-container>
